var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 5.25h2.63v2.63H5.25V14H2.62V7.87H0V5.25h2.63v-1.1c0-1.04.32-2.35.97-3.07A3.15 3.15 0 0 1 6.04 0h1.83v2.63H6.04a.79.79 0 0 0-.79.78z"
  })));
};
export default SvgFacebook;